<template>
    <div></div>
</template>

<script>
export default {
    name: "MarsReplacements"
}
</script>

<style scoped>

</style>